import { fifaTlaToFlagCode } from '../utils/teamFlagCode';
import { clubLogoUrl } from '../utils/clubLogoUrl';
import { isWcLeagueCode } from '../utils/leagues';
import { isTeamDisplayPending } from '../utils/formatTeamDisplayName';

/**
 * Club crest (domestic) or national flag (World Cup) beside team names.
 */
export default function ClubCrest({ leagueCode, teamLabel, teamTla, className = '' }) {
  if (isTeamDisplayPending(teamLabel)) return null;
  if (isWcLeagueCode(leagueCode)) {
    const code = fifaTlaToFlagCode(teamTla);
    if (!code) return null;
    return (
      <span
        className={`fi fi-${code} team-crest team-crest--flag ${className}`.trim()}
        aria-hidden="true"
      />
    );
  }

  const src = clubLogoUrl(leagueCode, teamLabel);
  if (!src) return null;
  return (
    <img
      src={src}
      alt=""
      className={`team-crest ${className}`.trim()}
      loading="lazy"
      width={40}
      height={40}
      onError={(e) => {
        e.currentTarget.style.display = 'none';
      }}
    />
  );
}
